export default {
  ai_explanation: {
    title: "Estimator24 Sistemi Nasıl Çalışır",
    intro:
      "Estimator24, gayrimenkulün gerçek piyasa değerini onlarca faktöre göre belirlemek için yapay zekâ ve veri analizini kullanır.",
    how_it_works: {
      title: "Fiyat Nasıl Hesaplanır",
      step1: "Sistem, 20 km yarıçapındaki benzer daireleri bulur.",
      step2: "Alan, kat, inşa yılı, manzara ve altyapı gibi özellikleri analiz eder.",
      step3: "Birden fazla makine öğrenmesi modeli bağımsız tahminler üretir.",
      step4: "Nihai fiyat, piyasa eğilimlerine göre ayarlanmış ağırlıklı ortalamadır."
    },
    models: {
      title: "Estimator24 Modelleri",
      xgboost: "Mevcut tüm parametreleri analiz eden kapsamlı bir model.",
      lightgbm: "Gayrimenkulü yakın çevredeki benzerleriyle karşılaştırır.",
      randomforest: "Nadir özellik kombinasyonlarını ve düşük fiyatlı daireleri belirler.",
      neural: "Geçmiş verilere ve gayrimenkul fotoğraflarına dayalı olarak eğitilmiş sinir ağı.",
      regression: "Genel piyasa dinamiklerini yansıtan istatistiksel bir model."
    },
    market: {
      title: "‘Piyasanın Altında’ veya ‘Üzerinde’ Ne Anlama Geliyor?",
      desc: "Fiyat ortalamanın altındaysa fırsat olabilir; üzerindeyse dairenin konumu, manzarası veya durumu daha iyi olabilir. Estimator24 tüm verileri karşılaştırarak gerçek piyasa pozisyonunu gösterir."
    }
  }
}
